import { useProductMetadata } from '@ztechapps/product.webui'
import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import map from 'lodash/map'
import { CategoryNavDropdownItem } from '../../../components/Header/menu/CategoryNavDropdownItem'
import { Icon } from '@ztechapps/webui.util'

export const ProductCategoryNavLink = () => {
  const { metadataSchema }: { metadataSchema: any } = useProductMetadata()
  const [categories, setCategory] = React.useState<any>()

  React.useEffect(() => {
    if (metadataSchema) {
      const options: any[] = metadataSchema?.category?.inputProps?.options ?? []
      setCategory([...options])
    }
  }, [metadataSchema])

  return (
    <NavDropdown
      title={
        <span className="fw-bold">
          <Icon name="bars" /> All category
        </span>
      }
      id="category-nav-dropdown"
    >
      {map(categories, (category: any) => (
        <CategoryNavDropdownItem key={category?.value} category={category} {...{ categoryFilter: category?.value }} />
      ))}
    </NavDropdown>
  )
}
